import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SurfingIcon from "@mui/icons-material/Surfing";
import { Link } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { LogInButton } from "../../features/user/components/LogInButton";
import { selectSession, signOut } from "../../features/user/userSlice";

function NavBar() {
  const dispatch = useDispatch();
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const session = useSelector(selectSession);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const logOut = () => {
    dispatch(signOut());
  };

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {" "}
          <Link
            component={RouterLink}
            to="/"
            color="inherit"
            underline="none"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <SurfingIcon sx={{ mr: 1 }} />
            <Typography
              variant="h6"
              noWrap
              sx={{
                mr: 2,
                display: { xs: "none", sm: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",

                textDecoration: "none",
              }}
            >
              Work Surf Repeat
            </Typography>
          </Link>
          {!session ? (
            <Box sx={{ flexGrow: 0 }}>
              {" "}
              <LogInButton variant="contained" />{" "}
            </Box>
          ) : (
            <Box sx={{ flexGrow: 0 }}>
              {" "}
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <AccountCircleIcon color="secondary" fontSize="large" />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem key={"profile"} onClick={handleCloseUserMenu}>
                  <Link
                    component={RouterLink}
                    underline="none"
                    to={`/profile`}
                    name={"profile"}
                  >
                    <Typography textAlign="center">Profile</Typography>{" "}
                  </Link>
                </MenuItem>

                <MenuItem key={"logOut"} onClick={logOut}>
                  <Typography textAlign="center">Log Out</Typography>{" "}
                </MenuItem>
              </Menu>{" "}
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default NavBar;
